import classnames from 'classnames';
import type { FC } from 'react';

import { Text } from '@/core/tamagoshi/Text/Text';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Link } from '@/domains/core/routing/components/Link';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import type { MdScore } from '@/domains/productDiscovery/ArticleReviews/ArticleReviews.model';
import { useMdScores } from '@/domains/productDiscovery/ArticleReviews/MdScores.ducks';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useSidePanel } from '@/domains/productDiscovery/ProductPage/hooks/useSidePanel';

import { electedByCustomers, top, valueForMoney } from './translations';

import styles from './newTopMdScores.module.scss';

export const NewTopMdScores: FC = () => {
  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);
  const { goToReview } = useSidePanel();
  const { data } = useMdScores();

  const isTopValueForMoney = data?.some(
    (mdScore: MdScore) => mdScore.questionId === 1 && mdScore.isTop,
  );

  if (!isTopValueForMoney) return null;

  if (isProductPageRevampEnabled)
    return (
      <button
        type="button"
        className="flex w-fit flex-col items-start overflow-hidden"
        onClick={goToReview}
      >
        <Typography as="span" weight="bold" scale="tiny">
          {top} {valueForMoney}
        </Typography>
        <Typography
          as="span"
          weight="semibold"
          scale="tiny"
          className="text-foundation-secondary underline"
        >
          {electedByCustomers}
        </Typography>
      </button>
    );

  return (
    <Link
      href="#reviews-container"
      className={classnames(styles.container, styles.unstyledLink)}
      data-testid="new-top-md-scores"
      scroll={false}
      shallow
    >
      <Text className={styles.bold}>
        {top} {valueForMoney}
      </Text>
      <Text className={styles.regular}>{electedByCustomers}</Text>
    </Link>
  );
};
